import { Grid } from '@mui/material'
import { Control, FieldErrors } from 'react-hook-form'
import { TSale } from '../../core/types/Sale'
import TextFieldRequired from '../Inputs/TextFieldRequired'
import { useTranslation } from 'react-i18next'

interface InternationalAddressProps {
  control: Control<TSale>
  errors: FieldErrors<TSale>
}

const InternationalAddress = ({ control, errors }: InternationalAddressProps) => {
  const { t } = useTranslation()

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <TextFieldRequired
          control={control}
          fieldName="address.street"
          label={t('internationalAddress.street')}
          helperText={errors.address?.street?.message}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextFieldRequired
          control={control}
          fieldName="address.zipCode"
          label={t('internationalAddress.postalCode')}
          helperText={errors.address?.zipCode?.message}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextFieldRequired
          control={control}
          fieldName="address.city"
          label={t('internationalAddress.city')}
          helperText={errors.address?.city?.message}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldRequired
          control={control}
          fieldName="address.state"
          label={t('internationalAddress.state')}
          helperText={errors.address?.state?.message}
          required
        />
      </Grid>
    </Grid>
  )
}

export default InternationalAddress
